import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/footer/logo_sachsen_geht_weiter.webp")